var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("VTextField", {
    staticClass: "flex-column ns-credit-card",
    attrs: {
      name: "cardNumber",
      type: "tel",
      "validate-on-blur": "",
      label: _vm.t.fieldLabel,
      mask: _vm.cardMask,
      maxlength: "16",
      rules: _vm.isValidNumber,
      placeholder: _vm.t.placeholder,
      disabled: _vm.fieldDisabled
    },
    on: {
      blur: function($event) {
        return _vm.validateLuhn()
      },
      input: _vm.updatedCardNumber
    },
    scopedSlots: _vm._u([
      {
        key: "append-outer",
        fn: function() {
          return _vm._l(_vm.ccOptions, function(card, index) {
            return _c("img", {
              key: index,
              staticClass: "p-icon",
              class: { "display-none": _vm.paymentTypeId !== card.id },
              attrs: { src: _vm.getCardIcon(card.id), alt: card.localizedName }
            })
          })
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.ccNumber,
      callback: function($$v) {
        _vm.ccNumber = $$v
      },
      expression: "ccNumber"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }